import React, { useEffect } from "react";
import styles from "./Alternance.module.scss";

import PageContainer from "../../Common/PageContainer/PageContainer";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { deplomes } from "./data";

import Presentation from "./SubPages/Presentation";
import AlterDegree from "./SubPages/AlterDegree";

function ALTERNANCE() {
  const navig = useNavigate();

  const links = [
    { name: "Présentation", link: "/presentation" },
    ...deplomes.map((item, index) => {
      return {
        name: `Diplôme ${index + 1}`,
        link: `/${item.title.toLowerCase().split(" ").join("-")}`,
      };
    }),
  ];

  useEffect(() => {
    navig(`/alternance/presentation`);
  }, []);

  return (
    <div className={styles.main}>
      <PageContainer title="ALTERNANCE" actual_link="/alternance" links={links}>
        <Routes>
          <Route path="/presentation" element={<Presentation />} />
          {deplomes.map((item, key) => {
            return (
              <Route
                key={key}
                path={`/${item.title.toLowerCase().split(" ").join("-")}`}
                element={<AlterDegree />}
              />
            );
          })}
          <Route
            path="/*"
            element={<Navigate to={"/alternance/presentation"} />}
          />
        </Routes>
      </PageContainer>
    </div>
  );
}

export default ALTERNANCE;
